// @flow
/* eslint arrow-parens:0 */

import type { Action } from 'app/common/redux/types';

type Toast = {
  name: string,
};
export type State = Toast[];
const toasts = (state: State = [], action: Action): State => {
  if (action.type === 'TOAST_SHOW') {
    return [...state, action.payload];
  } else if (action.type === 'TOAST_HIDE') {
    const { name } = action.payload;
    const idx = state.findIndex((toast) => toast.name === name);
    if (idx !== -1) {
      const nextState = [...state];
      nextState.splice(idx, 1);
      return nextState;
    }
  }
  return state;
};

export default toasts;
